import React from "react";
import ContentLoader from "react-content-loader";

const BlogListLoadingItem = (props) => (
  <ContentLoader
    speed={2}
    width={400}
    height={350}
    viewBox="0 0 400 350"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb"
    {...props}
  >
    <rect x="0" y="0" rx="3" ry="3" width="400" height="280" />
    <rect x="0" y="297" rx="0" ry="0" width="394" height="19" />
    <rect x="0" y="329" rx="0" ry="0" width="244" height="10" />
  </ContentLoader>
);

export default BlogListLoadingItem;
